import { render, staticRenderFns } from "./BreadcrumbBanner.vue?vue&type=template&id=da10fd0a&scoped=true&"
import script from "./BreadcrumbBanner.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbBanner.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbBanner.vue?vue&type=style&index=0&id=da10fd0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da10fd0a",
  null
  
)

/* custom blocks */
import block0 from "./BreadcrumbBanner.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports